import { ReactNode } from 'react';
import { ViewStyle } from 'react-native';

export enum PopupSize {
  STANDARD = 'standard',
  WIDE = 'wide',
  BIG = 'big',
}

export interface PopupProps {
  title: ReactNode;
  isCentered?: boolean;
  isClosable?: boolean;
  isBig?: boolean,
  isLong?: boolean
  isSecondPopup?: boolean;
  content: ReactNode;
  buttons?: ReactNode;
  popupId?: string,
  style?: ViewStyle,
  className?: string,
  size?: PopupSize,
  testId?: string,
}

export const POPUP_DATA_UPDATED = 'POPUP_DATA_UPDATED';

export const POPUP_OPENED = 'POPUP_OPENED';
